import Comments from "./comments";
export default Comments;
